import atoms from "../../../atoms";
import { Eye, PrescriptionRowProps, TLens, View } from "../interface";

const {Input} = atoms

export const PrescriptionRow = ({
    label,
    lens,
    eye,
    view,
    showLabels,
  }: PrescriptionRowProps) =>{ 

    const getPrescription = (lens: TLens, eye: Eye, view: View, field: string) =>
        lens?.prescription_details?.[`${eye}_${view}_${field}`] || "";
    
    return (
    <div className="d-flex gap-1 mt-2">
      <div className="align-items-center d-flex col-2">
        <h4 className="fs-16 fw-600 secondary-color">{`${label} :`}</h4>
      </div>
      {["sph", "cyl", "axis", "pd"].map((key) => (
        <div key={key}>
          <Input
            type="text"
            onChange={() => ""}
            disabled={true}
            label={showLabels ? key.toUpperCase() : undefined}
            value={getPrescription(lens, eye, view, key)}
            placeholder=""
          />
        </div>
      ))}
    </div>
  )};